var map = {
	"./007-microphone-1.png": 1331,
	"./010-home.png": 65449,
	"./013-document-1.png": 94678,
	"./014-document.png": 34690,
	"./015-color-palette.png": 47228,
	"./017-video-camera.png": 85817,
	"./Learning-logo-black-1400X320.png": 76385,
	"./Learning-logo-white-1400X320.png": 46836,
	"./arrow-left.png": 41755,
	"./arrow-right.png": 55831,
	"./bell.svg": 86316,
	"./envelope.svg": 32128,
	"./google-plus.svg": 30381,
	"./home.svg": 53002,
	"./learning-black.png": 68575,
	"./learning-white.png": 80066,
	"./left-bar.svg": 13938,
	"./logo-white (1).png": 31075,
	"./setting.svg": 97849,
	"./tesseract-assessment-logo.png": 37584,
	"./tesseract-learning-logo.png": 63948,
	"./tesseractLogoAndText.png": 87157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34542;